import $ from "jquery";

let iconPath;
var datepickereElement = $(".datepicker-input");
var dateToday = new Date();

if (location.host.indexOf("localhost") >= 0) {
    iconPath = window.location.origin + "/assets/img/icons/datepicker.png";
} else {
    iconPath = window.location.origin + "/patternlibrary/dist/assets/img/icons/datepicker.png";
}

// initialize jquery-ui datepicker
// https://api.jqueryui.com/datepicker/
if (datepickereElement.length) {
    $(datepickereElement).each(function () {
        var datepickerID = "#" + $(this).attr("id");

        $(datepickerID).datepicker({
            showOn: "button",
            buttonImage: iconPath,
            buttonImageOnly: false,
            dayNamesShort: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ],
            maxDate: new Date(),
            minDate: new Date(dateToday.setFullYear(dateToday.getFullYear() - 10)) // 10 year range
        });
    });
}

var htmlElement = document.getElementsByTagName('html')[0];
var datePickerBtn = document.getElementsByClassName('ui-datepicker-trigger')[0];

// Create an observer instance linked to the callback function
var observer = new MutationObserver(checkInput);

// Due to datepicker a11y issues
// removing datepicker from tab order for keyboard users
if (datePickerBtn) {
    observer.observe(htmlElement, {
        attributes: true,
        attributeFilter: ["data-whatintent"],
        attributeOldValue: true
    });
}

// Keep track of device
function checkInput(mutationList) {
    mutationList.forEach(function (mutation) {
        if (mutation.attributeName == 'data-whatintent') {
            if (mutation.oldValue != 'mouse') {
                datePickerBtn.removeAttribute('tabindex');
            } else {
                datePickerBtn.setAttribute('tabindex', '-1');
            }
        }
    });
}

var dateRegEx = /^(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.]\d{4}$/;

// Custom purchase date validator
// displays conditional error messaging
function purchaseDateValidator($el, required) {
    if (!required) return true;

    var valueEntered = $($el).val();
    var dateObject = new Date(valueEntered);

    // Does the input have a value
    if (valueEntered !== '') {
        // Is value entered in correct format
        if (dateRegEx.test(valueEntered)) {
            var dateTimeFormat = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });
            // format date and remove ghost characters from formatted string (ie11 issue)
            var formattedDate = dateTimeFormat.format(dateObject).replace(/[^\x20-\x7E]/g, '');

            // Is value entered a valid date
            // Compare string value to formatted date version to ensure it is a valid date
            if (valueEntered == formattedDate) {
                // If date is not a future date
                if (dateObject < new Date()) {

                    var currentYear = new Date().getFullYear();
                    var yearEntered = new Date(valueEntered).getFullYear();
                    var minYear = currentYear - 10;

                    // Is date within ten year range
                    if (yearEntered >= minYear) {
                        return true;
                    } else {
                        $('[data-form-error-for="purchase-date"]').html('Purchase date must be later than ' + minYear);
                        return false;
                    }
                } else {
                    $('[data-form-error-for="purchase-date"]').html('Purchase date cannot be a future date');
                    return false;
                }
            } else {
                $('[data-form-error-for="purchase-date"]').html('Invalid date');
                return false;
            }
        }
        else {
            $('[data-form-error-for="purchase-date"]').html('A valid date with the following format is required: MM/DD/YYYY');
            return false;
        }
    } else {
        $('[data-form-error-for="purchase-date"]').html('Purchase date required');
        return false;
    }
};

// Set default options
Foundation.Abide.defaults.validators['purchase_date'] = purchaseDateValidator;

